import { type HttpBadStatusCodeError, type UnknownError } from '@cian/peperrors/shared';

import { EQueryKeys } from '@/packages/query-state/shared/store/EQueryKeys';

export type QueryError = UnknownError | HttpBadStatusCodeError;

export type QueryKey = [EQueryKeys.Favorites__V1_DeleteOfferFromFavorites];

export const getQueryKey = (): QueryKey => [EQueryKeys.Favorites__V1_DeleteOfferFromFavorites];
